import { FormattedText } from '@/components/pages/applicant-dashboard/offers/FormattedFulfilmentData';
import { FulfilmentRendererProps } from '@/components/pages/applicant-dashboard/offers/requirement-rows';
import { parseDate, formatDate } from 'shared-components';
import { JSX } from 'react';
import {
  ApplicantOfferPaymentMethod,
  ApplicantOfferPaymentSponsorType,
  IOfferFinancePaymentFulfilmentData,
} from 'types';

const sponsorTypeLabelMap: Record<ApplicantOfferPaymentSponsorType, string> = {
  [ApplicantOfferPaymentSponsorType.UkGovernment]: 'UK Government',
  [ApplicantOfferPaymentSponsorType.BritishCouncil]: 'British Council',
  [ApplicantOfferPaymentSponsorType.YourGovernment]: 'Your Government',
  [ApplicantOfferPaymentSponsorType.InternationalOrganisation]: 'International Organisation',
  [ApplicantOfferPaymentSponsorType.InternationalCompany]: 'International Company',
};

export default function PaymentFulfilmentRenderer({ fulfilmentData }: FulfilmentRendererProps): JSX.Element | null {
  const payment = fulfilmentData as IOfferFinancePaymentFulfilmentData;

  if (!payment?.paymentMethod) return null;

  let text: string | undefined;
  let subtext: string | undefined;

  if (payment.paymentMethod === ApplicantOfferPaymentMethod.Deposit) {
    text = `£${payment.depositDetail?.depositAmount?.toLocaleString() ?? '0'} deposit paid`;
    subtext = formatDate(parseDate(payment.depositDetail?.paymentDate), 'D MMM YYYY');
  } else if (payment.paymentMethod === ApplicantOfferPaymentMethod.Sponsorship) {
    const { sponsorName, sponsorType, isSponsorOrgMultinational } = payment?.sponsorshipDetail ?? {};
    text = sponsorName ? `Sponsorship from ${sponsorName}` : undefined;
    if (
      [
        ApplicantOfferPaymentSponsorType.InternationalCompany,
        ApplicantOfferPaymentSponsorType.InternationalOrganisation,
      ].includes(sponsorType)
    ) {
      const isInternationalCompany = sponsorType === ApplicantOfferPaymentSponsorType.InternationalCompany;
      subtext = `International ${isInternationalCompany ? 'company' : 'organisation'} \n ${
        isSponsorOrgMultinational ? 'Presence' : 'No presence'
      } in more than 1 country`;
    } else {
      subtext = sponsorTypeLabelMap[sponsorType];
    }
  } else if (payment.paymentMethod === ApplicantOfferPaymentMethod.SLCFunding) {
    text = 'Student Loan Company financing';
    subtext = `CRN: ${payment.slcDetail?.customerRefNumber} \n SSN: ${payment.slcDetail?.studentSupportNumber}`;
  }

  if (!text) return null;

  return <FormattedText text={text} subtext={subtext} />;
}
